<template>
  <div class="tw-bg-white tw-rounded-lg tw-p-8 tw-pb-4">
    <slot />
  </div>
</template>
